'use strict';
define([
    'angular',
    'modules/seochecker/translations/translations.controller'
], function (angular, SCTranslationsCtrl) {
    var app = angular.module('app.seochecker.translations', []);
    app.controller('SCTranslationsCtrl', SCTranslationsCtrl);
    return app;
});
